// ============================================
// Artículo 3: La Ciencia detrás del Confort Térmico
// Lógica específica: Chart.js + Calculadora
// ============================================

(function () {
  'use strict';

  // --- Gráfico Costos ---
  var ctxCosto = document.getElementById('ct-costo-chart');
  if (ctxCosto) {
    new Chart(ctxCosto.getContext('2d'), {
      type: 'bar',
      data: {
        labels: ['U-STUCCO', 'Ecorkret', 'Presec T-25', 'Termi Estuco'],
        datasets: [{
          label: 'Costo CLP por m² (5mm)',
          data: [7125, 4000, 3634, 12160],
          backgroundColor: ['#E67E22', '#BDC3C7', '#BDC3C7', '#BDC3C7'],
          borderRadius: 8
        }]
      },
      options: {
        maintainAspectRatio: false,
        plugins: { legend: { display: false } },
        scales: { y: { beginAtZero: true, title: { display: true, text: 'Pesos Chilenos ($)' } } }
      }
    });
  }

  // --- Gráfico Térmico ---
  var ctxTermico = document.getElementById('ct-termico-chart');
  if (ctxTermico) {
    new Chart(ctxTermico.getContext('2d'), {
      type: 'bar',
      data: {
        labels: ['U-STUCCO', 'Ecorkret', 'Presec T-25', 'Termi Estuco'],
        datasets: [{
          label: 'Conductividad Térmica λ (W/mK)',
          data: [0.080, 0.097, 0.200, 0.180],
          backgroundColor: ['#3498DB', '#BDC3C7', '#E74C3C', '#BDC3C7'],
          borderRadius: 8
        }]
      },
      options: {
        indexAxis: 'y',
        maintainAspectRatio: false,
        plugins: {
          legend: { display: false },
          tooltip: { callbacks: { label: function(ctx) { return 'λ: ' + ctx.raw + ' W/mK'; } } }
        },
        scales: { x: { beginAtZero: true, title: { display: true, text: 'W/mK (Menos es mejor)' } } }
      }
    });
  }

  // --- Calculadora nueva ---
  function calculateUstucco() {
    var area      = parseFloat(document.getElementById('calc-area').value) || 0;
    var thickness = parseFloat(document.getElementById('calc-thickness').value) || 0;
    var pricePerBag = 57000;
    var exactBags   = (area * thickness) / 40;
    var roundedBags = Math.ceil(exactBags);
    var totalCost   = roundedBags * pricePerBag;

    var exactEl   = document.getElementById('result-exact');
    var bagsEl    = document.getElementById('result-bags');
    var costEl    = document.getElementById('result-cost');

    if (exactEl) exactEl.innerText = exactBags.toFixed(2);
    if (bagsEl)  bagsEl.innerText  = roundedBags;
    if (costEl)  costEl.innerText  = new Intl.NumberFormat('es-CL', {
      style: 'currency', currency: 'CLP', maximumFractionDigits: 0
    }).format(totalCost);
  }

  var calcArea      = document.getElementById('calc-area');
  var calcThickness = document.getElementById('calc-thickness');
  if (calcArea)      calcArea.addEventListener('input', calculateUstucco);
  if (calcThickness) calcThickness.addEventListener('input', calculateUstucco);
  calculateUstucco();

  // --- IA: preguntas frecuentes ---
  var iaSystem = 'Eres un experto en morteros térmicos y eficiencia energética en construcción chilena. Compara U-STUCCO con otros productos del mercado de forma técnica y objetiva. Responde en español, de forma concisa y práctica.';

  var iaBtn    = document.getElementById('ct-ia-btn');
  var iaInput  = document.getElementById('ct-ia-input');
  var iaSelect = document.getElementById('ct-ia-select');
  var iaResult = document.getElementById('ct-ia-result');
  var iaSpinner = iaBtn ? iaBtn.querySelector('.art-spinner') : null;

  if (iaSelect && iaInput) {
    iaSelect.addEventListener('change', function () {
      if (iaSelect.value) iaInput.value = iaSelect.value;
    });
  }

  if (iaBtn) {
    iaBtn.addEventListener('click', async function () {
      var text = iaInput ? iaInput.value.trim() : '';
      if (!text) return;
      iaBtn.disabled = true;
      if (iaSpinner) iaSpinner.style.display = 'inline-block';
      if (iaResult)  iaResult.style.display  = 'none';
      try {
        var answer = await window.portalCallIA(iaSystem, text);
        if (iaResult) {
          iaResult.innerHTML = answer.replace(/\n/g, '<br>');
          iaResult.style.display = 'block';
        }
      } catch (e) {
        if (iaResult) { iaResult.innerHTML = 'Error al consultar. Intenta nuevamente.'; iaResult.style.display = 'block'; }
      } finally {
        iaBtn.disabled = false;
        if (iaSpinner) iaSpinner.style.display = 'none';
      }
    });
  }

})();
